import React from 'react';
import { Modal } from '@tradingblock/components';
import { Modal as BootstrapModal, Button } from 'react-bootstrap';
import { SymbolChannels } from '../../types';

interface ChannelEditModalProps {
    editingSymbol: SymbolChannels | null;
    show: boolean;
    selectedChannels: string[];
    availableChannels: string[];
    onClose: () => void;
    onSave: () => void;
    onToggleChannel: (channel: string) => void;
    addSpaceBeforeCaps: (str: string) => string;
}

export const ChannelEditModal: React.FunctionComponent<ChannelEditModalProps> = ({
    editingSymbol,
    show,
    selectedChannels,
    availableChannels,
    onClose,
    onSave,
    onToggleChannel,
    addSpaceBeforeCaps,
}) => {
    if (!editingSymbol) return null;

    return (
        <Modal size="lg" setShow={onClose} show={show} className="remove-position">
            <BootstrapModal.Header closeButton>
                <BootstrapModal.Title>
                    Edit Channels for {editingSymbol.name}
                </BootstrapModal.Title>
            </BootstrapModal.Header>
            <BootstrapModal.Body>
                <div style={{ marginBottom: '1rem' }}>
                    <label style={{ fontWeight: 'bold', marginBottom: '0.5rem', display: 'block' }}>
                        Select Channels:
                    </label>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                        {availableChannels.map(channel => (
                            <label
                                key={channel}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    cursor: 'pointer',
                                    padding: '0.5rem',
                                    borderRadius: '4px',
                                    backgroundColor: selectedChannels.includes(channel) ? 'rgba(33, 150, 243, 0.1)' : 'transparent',
                                }}
                            >
                                <input
                                    type="checkbox"
                                    checked={selectedChannels.includes(channel)}
                                    onChange={() => onToggleChannel(channel)}
                                    style={{ marginRight: '0.5rem', cursor: 'pointer' }}
                                />
                                <span>{addSpaceBeforeCaps(channel)}</span>
                            </label>
                        ))}
                    </div>
                </div>
                {selectedChannels.length === 0 && (
                    <div style={{ color: '#d32f2f', fontSize: '0.875rem', marginTop: '0.5rem' }}>
                        Must have at least one channel selected!
                    </div>
                )}
            </BootstrapModal.Body>
            <BootstrapModal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button
                    variant="primary"
                    onClick={onSave}
                    disabled={selectedChannels.length === 0}
                >
                    Save
                </Button>
            </BootstrapModal.Footer>
        </Modal>
    );
};

